import React from 'react';
import Hero from '../components/home/Hero';
import ReelsSection from '../components/home/ReelsSection';
import {
  Craftsmanship,
  FeaturedCollections,
  Legacy,
  Marquee,
  Pillars,
  Signature,
  Testimonials,
  VisitUs,
} from '../components/home/Sections';
import usePageMeta from '../hooks/usePageMeta';

export default function Home() {
  usePageMeta({
    title: 'Pramukh Jewellers | Antique, Bridal & Diamond Jewellery, Ahmedabad',
    description:
      'Antique, bridal, temple, polki and diamond jewellery since 1997. Visit us at Fortune Business Hub, Science City Road, Sola, Ahmedabad.',
    path: '/',
  });

  return (
    <>
      <Hero />
      <Marquee />
      <Legacy />
      <FeaturedCollections />
      <Craftsmanship />
      <Signature />
      <ReelsSection />
      <Pillars />
      <Testimonials />
      <VisitUs />
    </>
  );
}
